import React, { useState, useRef, useEffect } from 'react';
import './MyDropdownButton.css';

function MyDropdownButton({ options }) {
    const [isOpen, setIsOpen] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);
    const handleButtonMouseEnter = () => setShowTooltip(true);
    const handleButtonMouseLeave = () => setShowTooltip(false);
    const handleDropdownLeave = () => setIsOpen(false);

    const handleOptionClick = (action) => {
        action();  // Execute the option's action
        setIsOpen(false);  // Close the dropdown
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className="dropdown-container" ref={dropdownRef}>
            <button 
                onClick={toggleDropdown} 
                onMouseEnter={handleButtonMouseEnter} 
                onMouseLeave={handleButtonMouseLeave} 
                className="dropdown-toggle"
            >
                •••
                {/* {showTooltip && <div className="tooltip">More Options</div>} */}
            </button>
            {isOpen && (
                <div className="dropdown-menu" onMouseLeave={handleDropdownLeave}>
                    {options.map((option, index) => (
                        <button key={index} onClick={() => handleOptionClick(option.action)}>
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default MyDropdownButton;